import { Component, Input } from '@angular/core';
import { ProgressBarModule } from 'primeng/progressbar';

@Component({
  selector: 'app-progress-bar',
  imports: [ProgressBarModule],
  templateUrl: '../ui/progress-bar.component.html',
  styleUrl: '../ui/progress-bar.component.css'
})
export class ProgressBarComponent {
  @Input({ required: true}) value!: number;
  @Input({required: true}) max!: number;
  @Input({required: true}) label!: string;

  get percentageValue(): number {
    return (100 / this.max) * this.value;
  }
}
